<template>
    <div>
        <div class="combo-meal">
            <div class="combo-inner">
                <div class="header-wrapper">
                    <div class="header-wrapper__title">{{ $t('Start authentic Chinese journey') }}</div>
                </div>
                <div class="tab">
                    <button
                        :class="['tab-btn', activeName === 'credit' && 'active']"
                        @click="handleBtnChange('credit')"
                    >{{ $t('Lesson Top-up') }}</button>
                    <button
                        :class="['tab-btn', activeName === 'vip' && 'active']"
                        @click="handleBtnChange('vip')"
                    >{{ $t('Membership Subscription') }}</button>
                </div>
                <div class="card-wrapper">
                    <img v-if="isMobile" class="icon" src="../assets/img/priceCard/left.png" @click="handleArrowClick('left')" />
                    <PriceCard
                        ref="priceCard"
                        :isActive="priceActive === idx"
                        :isRecommend="idx === originPriceList.length - 1"
                        :kidsActive="kidsActive"
                        @mouseenter.native="
                            () => {
                                !isMobile && (priceActive = idx);
                            }
                        "
                        class="card-wrapper__item"
                        v-for="(item, idx) in priceList"
                        :key="item.id"
                        :priceInfo="item"
                        :index="isMobile ? priceSelect : idx"
                        :activeName="activeName"
                        :isMobile="isMobile"
                        @btnClick="handlePriceClick(item.id)"
                        @kidChange="kidClick" />
                    <img v-if="isMobile" class="icon" @click="handleArrowClick('right')" src="../assets/img/priceCard/right.png" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PriceCard from '../components/PriceCard.vue';

import { loadingData } from '../utils';
import { getUser } from '../store/user';
import { getPlanList, getCreatPlanList, getFaqList } from '../api';
import { setStore, keys } from '../store';
import { setUser } from '../store/user';
import i18n from '../locales/i18n';
import { normalizeLocale } from '../utils/locale';
export default {
    components: {
        PriceCard,
    },
    data() {
        return {
            kids: {
                1: { value: '1', planList: [] },
                2: { value: '2', planList: [] },
                3: { value: '3', planList: [] },
            },
            kidsActive: '1',
            creatPlanList: [],
            faq: {
                active: 0,
                list: [],
            },
            comment: {
                index: 0,
                count: 4,
            },
            user: null,
            btnFlag: false,
            activeName: 'credit',
            priceActive: 0,
            priceSelect: 0,
            isMobile: false,
            lang:null
        };
    },
    created() {
      let { token } = this.$route.query;
      if(token){
        setStore(keys.token, token)
        setUser()
      }else if (normalizeLocale(this.$route.params.id)) {
        this.$router.replace({ params: { id: '' }, query: this.$route.query });
      }
      this.lang = i18n.locale;
  },
    mounted() {
        loadingData(async () => {
            this.user = getUser();
            if (this.user) {
                await setUser();
                this.user = getUser();
            }
            let datas = await Promise.all([getPlanList(1, this.user ? this.user.user_info.user_sn : ''), getCreatPlanList(this.user ? this.user.user_info.user_sn : ''), getFaqList()]);
            this.$set(this.kids[this.kidsActive], 'planList', datas[0]);

            this.creatPlanList = datas[1];
            this.$set(this.faq, 'list', datas[2]);
            this.changePriceSelect()
        });

        window.addEventListener('resize', (ev) => {
            this.deviceWidth();
        });
        this.deviceWidth();
    },
    computed: {
        isMember() {
            if (!this.user) return false;

            if (this.user.user_info.member_status === 0) return false;

            return true;
        },
        wrapperTitle() {
            return this.activeName === 'credit' ?  this.$t('Pay-as-You-Go')  : this.$t('Unlimited Lesson Plan');
        },
        wrapperSubTitle() {
            return this.activeName === 'credit' ? this.$t(`Enrich kids education and keep them ahead of the curve`) : this.$t(`One Pass that Meets Your Kids Learning Needs`);
        },
        originPriceList() {
            let list = [];
            if (this.activeName === 'credit') {
                list = this.creatPlanList || [];
            } else {
                list = this.kids[this.kidsActive]['planList'];
            }
            return list;
        },
        priceList() {
            return this.isMobile ? [this.originPriceList[this.priceSelect] || {}] : this.originPriceList;
        },
    },
    watch: {
        priceList() {
            this.priceActive = this.originPriceList.length - 1
        }
    },
    methods: {
        handleBtnChange(type) {
            this.activeName = type;
            this.changePriceSelect()
        },
        changePriceSelect() {
            setTimeout(() => {
                this.priceSelect = this.originPriceList.length - 1;
            }, 10);
        },
        handleArrowClick(type) {
            if (type === 'right') {
                this.priceSelect = this.priceSelect === this.originPriceList.length - 1 ? 0 : this.priceSelect + 1;
            } else {
                this.priceSelect = this.priceSelect === 0 ? this.originPriceList.length - 1 : this.priceSelect - 1;
            }
        },
        deviceWidth() {
            const width = (window.screen || {}).width || window.innerWidth || document.innerWidth;
            this.isMobile = width < 768;
        },
        handleScroll() {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var height = this.$refs.elemnt.offsetHeight;
            if (scrollTop > 160 + height) {
                this.btnFlag = true;
            } else {
                this.btnFlag = false;
            }
        },
        toTop() {
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            document.body.scrollTop = document.documentElement.scrollTop = 400;
        },
        async kidClick(kidNumber) {
            let active = kidNumber.toString();
            if (this.kids[active].planList.length <= 0) {
                await loadingData(async () => {
                    let data = await getPlanList(active, this.user ? this.user.user_info.user_sn : '');
                    this.$set(this.kids[active], 'planList', data);
                });
            }
            this.kidsActive = active;
        },
        // 套餐
        planClick(id) {
            if (!id) {
                this.$message(i18n.t('Package / Credit Package is not selected'));
                return;
            }
            if (!this.user) {
                setStore(keys.redirect, redirect);
                this.$router.push(redirect);
            }
            if (this.isMember) {
                const h = this.$createElement;
                this.$msgbox({
                    customClass: 'boxcss',
                    message: h('p', null, [h('span', null, i18n.t('Please contact our course advisor to upgrade your plan'))]),
                    closeOnClickModal: true,
                    confirmButtonText: i18n.t('Ok'),
                });
                return;
            }
          let query = {
            id,
            type: 'member'
          }
          if(this.$route.query && this.$route.query.token){
            query.token = this.$route.query.token
          }
            let redirect = { path: 'paymenthly', query};
            if (!this.user) setStore(keys.redirect, redirect);
            this.$router.push(redirect);
        },

        // 课程
        creatPlanClick(id) {
            if (!id) {
                this.$message(i18n.t('Package / Credit Package is not selected'));
                return;
            }
            let query = {
              id,
              type: 'credit'
            }
            if(this.$route.query && this.$route.query.token){
              query.token = this.$route.query.token
            }
            let redirect = { path: 'paymenthly', query};
            if (!this.user) setStore(keys.redirect, redirect);
            this.$router.push(redirect);
        },

        handlePriceClick(id) {
          if (this.activeName === 'credit') {
            this.creatPlanClick(id)
          } else {
            this.planClick(id)
          }
        },

        commentClick(value) {
            let nextIndex = this.comment.index + value;
            if (nextIndex < 0) return;
            if (nextIndex + 3 > this.comment.count) return;

            this.$refs.overContainer.scrollLeft = nextIndex * 330;
            this.comment.index = nextIndex;
        },
    },
};
</script>

<style lang="less" scoped>
.combo-meal {
    background:
        radial-gradient(ellipse 40% 30% at 15% 20%, rgba(181, 6, 4, 0.04), transparent 60%),
        radial-gradient(ellipse 35% 28% at 85% 15%, rgba(181, 6, 4, 0.035), transparent 55%),
        linear-gradient(180deg, #fff7f7 0%, #ffffff 48%, #ffffff 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "Microsoft YaHei", "Helvetica Neue", sans-serif;
    padding: 56px 16px 88px;
    box-sizing: border-box;
}

.combo-inner {
    width: 1200px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.header-wrapper {
    text-align: center;
    margin-bottom: 32px;

    &__title {
        font-size: 36px;
        color: #1a1a1a;
        font-weight: 700;
        line-height: 1.4;
        letter-spacing: 0.02em;
    }
}

.tab {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-bottom: 32px;

    &-btn {
        min-width: 220px;
        height: 52px;
        padding: 0 40px;
        border: 1.5px solid #B50604;
        border-radius: 10px;
        background: #fff;
        color: #B50604;
        font-size: 18px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

        &.active {
            background: #B50604;
            color: #fff;
            box-shadow: 0 6px 16px rgba(181, 6, 4, 0.25);
        }

        &:hover:not(.active) {
            background: #fff8f8;
        }
    }
}

.card-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 28px;
    box-sizing: border-box;

    &__item {
        flex: 1;
        max-width: 360px;
        min-width: 0;
    }

    .icon {
        object-fit: contain;
        padding: 5px;
        cursor: pointer;
        flex-shrink: 0;
    }
}

@media screen and (max-width: @device) {
    .combo-meal {
        padding: 28px 12px 48px;
    }

    .header-wrapper {
        margin-bottom: 20px;

        &__title {
            font-size: 22px;
            padding: 0 8px;
        }
    }

    .tab {
        width: 100%;
        gap: 10px;
        margin-bottom: 28px;

        &-btn {
            flex: 1;
            min-width: 0;
            height: 44px;
            padding: 0 12px;
            font-size: 15px;
        }
    }

    .card-wrapper {
        gap: 8px;
        align-items: center;

        &__item {
            flex: none;
            width: 78%;
            max-width: 320px;
        }
    }
}
</style>

<style lang="less">
body {
    position: relative;
    overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue